/**
 * @summary - Component that Provides Asset Condition List Page
 * @author Purushothaman T
 * @since 08-07-2024
 */
import React, { useEffect } from "react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import Modal from "@mui/material/Modal";

import { DefaultCard } from "../../assets/styled-components/card";
import { Box, IconButton, Stack, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useState } from "react";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import {
  getFacilityId,
  getcompanyId,
  getAuthToken,
} from "../../utility/tokenUtility";
import axios from "axios";
import { FemsGraph, BemsGraph, MasterGraph } from "../../utility/apiURLS";
import { useNavigate, useLocation } from "react-router-dom";
import utils from "../../utility/utilities";
import { assetcondition } from "../../utility/constants/masters";
import { assetCondition } from "../../utility/constants/errors/messages";
import { validations } from "../../utility/constants/errors/messages";
import { dialogContent as dialog } from "../../utility/message";
import CustomDialog from "../commoncomponents/CustomDialog";
import PageTitle from "../commoncomponents/PageTitle";
import PageLoader from "../commoncomponents/PageLoader";
import { set } from "react-hook-form";

const column = assetcondition.gridColumn;

const colDefs = [
  { field: column.date.field, headerName: column.date.header },
  {
    field: column.equipmentcondition.field,
    headerName: column.equipmentcondition.header,
    wrapHeaderText: true,
  },
];

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
};

const AssetConditionForm = () => {
  const [rowData, setRowData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [addedConditions, setAddedConditions] = useState([]);
  const [gridApi, setGridApi] = useState({});
  const [clearField, setClearField] = useState(false);
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const location = useLocation();
  const [service, setService] = useState("");
  const [equipmentCondition, setEquipmentCondition] = useState(false);
  const [assetno, setassetno] = useState("");
  const [assetnoOptions, setassetnoOptions] = useState([]);
  const [assetdesc, setassetdesc] = useState("");
  const [typecode, setTypeCode] = useState("");
  const [typedesc, setTypeDesc] = useState("");
  const [openValidationDialog, setOpenValidationDialog] = useState(false);
  const [disposalApproval, setDisposalApproval] = useState("");
  const [disposalDate, setDisposalDate] = useState("");
  const [isBackClicked, setIsBackClicked] = useState(false);
  const [disposalBy, setDisposalBy] = useState("");
  const [isChanged, setIsChanged] = useState(false);
  const [disposalMethod, setDisposalMethod] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const serviceOptions = [
    { id: 1, label: "FEMS", value: "FEMS" },
    { id: 2, label: "BEMS", value: "BEMS" },
  ];
  const [errors, setErrors] = useState({
    date: false,
    equipmentCondition: false,
    disposalBy: false,
    disposalMethod: false,
  });
  const [errorMessages, setErrorMessages] = useState({
    date: "",
    equipmentCondition: "",
    disposalBy: "",
    disposalMethod: "",
  });
  const navigate = useNavigate();
  const currentDate = utils.getCurrentDateFormatted("DD/MM/YYYY");
  const token = getAuthToken("id_token");
  const facilityId = getFacilityId("facilityId");
  const companyId = getcompanyId("companyId");
  const config = {
    headers: {
      // Attach bearer token to request header
      Authorization: `Bearer ${token}`,
    },
  };
  const toggleModal = (newOpen) => () => {
    setOpen(newOpen);
  };
  useEffect(() => {
    fetchdata();
  }, []);

  const fetchdata = async () => {
    if (location.state) {
      const { responseData, isEditMode, isViewMode, service } = location.state;
      setIsEdit(isEditMode);
      setIsView(isViewMode);
      if (isEditMode || isViewMode) {
        setassetno(responseData);
        setTypeCode(responseData.typecode);
        setTypeDesc(responseData.typeDescription);
        setService(
          serviceOptions.find((item) => item.label === responseData.service)
        );
        setDisposalStatus(responseData);
        setassetdesc(responseData.assetDescription);
        setRowData(
          responseData.assetStatusConditionVMs?.map((status) => {
            return {
              ...status,
              date: utils.formatDate({
                dateString: status.statusdate,
                format: "dd/mm/yyyy",
                dbdate: true,
              }),
              equipmentcondition: status.conditionstatus,
            };
          })
        );
      } else {
        setService(serviceOptions.find((item) => item.label === service));
        if (!isEdit && !isView) {
          await fetchOptions(serviceOptions.find((item) => item.label === service));
        }
      }
    }
  };
  const handleServiceChange = (newValue) => {
    if (newValue.label) {
      setService(newValue);
      setDeafault();
      fetchOptions(newValue);
    }
  };

  const handleDisposalApprovalChange = (newvalue) => {
    setIsChanged(true);
    setDisposalApproval(newvalue);
  };
  const handleDisposalDateChange = (newvalue) => {
    setIsChanged(true);
    setDisposalDate(newvalue);
  };

  const fetchOptions = async (service) => {
    setIsLoading(true);
    try {
      let assetCondition;
      if (service.label == "BEMS") {
        assetCondition = await axios.get(
          `${BemsGraph}/api/AssetConditionStatusAssetNo/GetBemAssetConditionAssetNoFetch/${facilityId}`,
          config
        );
      } else {
        assetCondition = await axios.get(
          `${FemsGraph}/api/AssetConditionStatusAssetNo/GetFemAssetConditionAssetNoFetch/${facilityId}`,
          config
        );
      }

      setassetnoOptions(
        assetCondition.data.map((data) => {
          const conditionStatus = data.assetStatusConditionVMs;
          return {
            ...data,
            service: service.label,
            date: utils.formatDate({
              dateString:
                conditionStatus[conditionStatus.length - 1]?.statusdate,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
            equipmentcondition:
              conditionStatus[conditionStatus.length - 1]?.conditionstatus,
            label: `${data.assetName} - ${data.assetDescription}`,
            value: data.assetName,
            id: data.assetId,
          };
        })
      );
    } catch (error) {
      console.error("Error fetching options:", error);
      // Handle error (e.g., show error message)
    } finally {
      setIsLoading(false);
    }
  };

  const setDeafault = () => {
    setassetno({ label: "", value: "" });
    setassetdesc("");
    setTypeCode("");
    setTypeDesc("");
    setDisposalStatus({});
    setRowData([]);
  }

  const handleAssetNoChange = (newvalue) => {
    if (newvalue.label == "") {
      setDeafault();
    } else {
      setassetno({ ...newvalue, label: newvalue.value });
      setassetdesc(newvalue.assetDescription);
      setTypeCode(newvalue.typecode);
      setTypeDesc(newvalue.typeDescription);
      setDisposalStatus(newvalue);
      setRowData(
        newvalue.assetStatusConditionVMs?.map((status) => {
          return {
            ...status,
            date: utils.formatDate({
              dateString: status.statusdate,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
            equipmentcondition: status.conditionstatus,
          };
        })
      );
    }
  };

  useEffect(() => {
    fetchConditionOptions();
  }, [assetno]);

  const fetchConditionOptions = async () => {
    try {
      if (service.label === "FEMS") {
        const statusOptionsFems = await axios.get(
          `${FemsGraph}/api/FemAssetConditionStatuses/GetFemCondStatusDropdownList/${companyId}/${facilityId}`,
          config
        );
        const femConditionStatusOptions =
          statusOptionsFems.data.femcondstatuses.map((status) => {
            return {
              ...status,
              id: status.id,
              value: status.conditionstatus,
              label: status.conditionstatus,
            };
          });
        setStatusOptions(
          femConditionStatusOptions.sort((a, b) =>
            a.conditionstatus.localeCompare(b.conditionstatus)
          )
        );
      }
      if (service.label === "BEMS") {
        const statusOptionsBems = await axios.get(
          `${BemsGraph}/api/BemAssetConditionStatuses/GetBemCondStatusDropdownList/${companyId}/${facilityId}`,
          config
        );

        const bemConditionStatusOptions =
          statusOptionsBems.data.bemcondstatuses.map((status) => {
            return {
              ...status,
              id: status.id,
              value: status.conditionstatus,
              label: status.conditionstatus,
            };
          });
        setStatusOptions(
          bemConditionStatusOptions.sort((a, b) =>
            a.conditionstatus.localeCompare(b.conditionstatus)
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setDisposalStatus = (newvalue) => {
    console.log(newvalue);
    setDisposalDate(
      newvalue.disposaldate
        ? utils.formatDate({
          dateString: newvalue.disposaldate,
          format: "dd/mm/yyyy",
          dbdate: true,
        })
        : ""
    );
    setDisposalApproval(
      newvalue.disposalapprovaldate
        ? utils.formatDate({
          dateString: newvalue.disposalapprovaldate,
          format: "dd/mm/yyyy",
          dbdate: true,
        })
        : ""
    );

    setDisposalBy(newvalue.disposalby ? newvalue.disposalby : "");
    setDisposalMethod(newvalue.disposalmethod ? newvalue.disposalmethod : "");
  };

  const handleDisposalCancel = () => {
    setIsBackClicked(true);
    if (addedConditions.length > 0 || isChanged) {
      handleDataChanges();
    } else {
      navigate("/assetcondition");
    }
  };

  const handleConditionSave = () => {
    let isFormValid = true;
    if (!date) {
      isFormValid = false;
      setErrors((prev) => ({ ...prev, date: true }));
      setErrorMessages((prev) => ({
        ...prev,
        date: assetCondition.date.required,
      }));
    }
    if (!equipmentCondition) {
      isFormValid = false;
      setErrors((prev) => ({ ...prev, equipmentCondition: true }));
      setErrorMessages((prev) => ({
        ...prev,
        equipmentCondition: assetCondition.equipmentcondition.required,
      }));
    } else if (rowData.length > 0) {
      if (
        rowData[rowData.length - 1].equipmentcondition ===
        equipmentCondition.label
      ) {
        isFormValid = false;
        setErrors((prev) => ({ ...prev, equipmentCondition: true }));
        setErrorMessages((prev) => ({
          ...prev,
          equipmentCondition: assetCondition.equipmentcondition.exist,
        }));
      }
    }
    if (isFormValid) {
      const newCondition = {
        date: date,
        equipmentcondition: equipmentCondition.label,
        statusdate: date,
        sequenceorder: rowData.length + 1,
        ...(service.label === "FEMS"
          ? { femcondstatusId: equipmentCondition.id }
          : { bemcondstatusId: equipmentCondition.id }),
        ...(service.label === "FEMS"
          ? { femassetregisterId: assetno.id }
          : { bemassetregisterId: assetno.id }),
      };
      setAddedConditions((prev) => [...prev, newCondition]);
      setRowData((prev) => [...prev, newCondition]);
      setDate("");
      setEquipmentCondition(null);
      setOpen(false);
    }
  };
  const handleDateChange = (newvalue) => {
    if (newvalue) {
      setErrors((prev) => ({ ...prev, date: false }));
      setErrorMessages((prev) => ({ ...prev, date: "" }));
    }    
    setDate(newvalue);
  };
  const handleEquipmentConditionChange = (newvalue) => {
    if (newvalue) {
      setErrors((prev) => ({ ...prev, equipmentCondition: false }));
      setErrorMessages((prev) => ({ ...prev, equipmentCondition: "" }));
    }
    setEquipmentCondition(newvalue);
  };

  const handleModalCancel = () => {
    setOpen(false);
    setErrors({
      date: false,
      equipmentCondition: false,
    });
    setErrorMessages({
      date: "",
      equipmentCondition: "",
    });
    setDate("");
    setEquipmentCondition(null);
  };
  const handleDisposalMethodChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, disposalMethod: false }));
      setErrorMessages((prev) => ({ ...prev, disposalMethod: "" }));
    }
    setDisposalMethod(newvalue);
    if (utils.validateTextField(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, disposalMethod: false }));
      setErrorMessages((prev) => ({ ...prev, disposalMethod: "" }));
    } else if (!utils.validateTextField(newvalue)) {
      setErrors((prev) => ({ ...prev, disposalMethod: true }));
      setErrorMessages((prev) => ({
        ...prev,
        disposalMethod: validations.textfield,
      }));
    }
  };
  const handleDisposalByChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, disposalBy: false }));
      setErrorMessages((prev) => ({ ...prev, disposalBy: "" }));
    }
    setDisposalBy(newvalue);
    if (utils.validateTextField(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, disposalBy: false }));
      setErrorMessages((prev) => ({ ...prev, disposalBy: "" }));
    } else if (!utils.validateTextField(newvalue)) {
      setErrors((prev) => ({ ...prev, disposalBy: true }));
      setErrorMessages((prev) => ({
        ...prev,
        disposalBy: validations.textfield,
      }));
    }
  };
  const handleDescClear = () => {
    if (addedConditions.length > 0 || isChanged) {
      handleDataChanges();
    } else {
      setClearField(true);
    }
  };
  const handleDataChanges = () => {
    setOpenDialog(true);
    setDialogContent(dialog.modified);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  const handleDialogConfirm = () => {
    if (addedConditions.length > 0 || isChanged) {
      setOpenDialog(false);
      if (isBackClicked) {
        navigate("/assetcondition");
      }
      setClearField(true);
      setIsChanged(false);
      return;
    }
    if (openValidationDialog) {
      setOpenValidationDialog(false);
    }
  };

  const handleAssetStatusSave = async () => {
    const postData = addedConditions.map((item) => {
      return {
        ...item,
        statusdate: utils.formatDate({
          dateString: item.statusdate,
          format: "YYYY-MM-DD",
          includeTime: true,
        }),
      };
    });
    const putData = {
      id: assetno.id,
      disposaldate: utils.formatDate({
        dateString: disposalDate,
        format: "YYYY-MM-DD",
        includeTime: true,
      }),
      disposalby: disposalBy,
      disposalmethod: disposalMethod,
      disposalapprovaldate: utils.formatDate({
        dateString: disposalApproval,
        format: "YYYY-MM-DD",
        includeTime: true,
      }),
    };
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    let apiPost, apiPut;
    if (service.label === "FEMS") {
      apiPost = `${FemsGraph}/api/AssetConditionStatusAssetNo/FemassetconditionstatusList`;
      apiPut = `${FemsGraph}/api/AssetConditionStatusAssetNo/${assetno.id}`;
    } else {
      apiPost = `${BemsGraph}/api/AssetConditionStatusAssetNo/BemassetconditionstatusList`;
      apiPut = `${BemsGraph}/api/AssetConditionStatusAssetNo/${assetno.id}`;
    }

    try {
      let responsePost;
      if (addedConditions.length > 0) {
        responsePost = await axios({
          method: "post",
          url: apiPost,
          headers: config.headers,
          data: postData,
        });
      }
      const responsePut = await axios({
        method: "put",
        url: apiPut,
        headers: config.headers,
        data: putData,
      });
      if (responsePut.status === 200 || responsePost.status === 201) {
        setOpenValidationDialog(true);
        setDialogContent(dialog.saved);
        setAddedConditions([]);
        setIsChanged(false);
        fetchOptions();
      }
    } catch (error) { }
  };

  return (
    <>
      <PageLoader open={isLoading} />
      <PageTitle
        title="Asset Condition"
        isView={isView}
        viewTitle={"View Asset Condition"}
      />
      <Box>
        <DefaultCard mb={2}>
          <Stack>
            <Grid container mb={2} spacing={4}>
              <Grid item xs={6} md={4}>
                <CustomSelectInput
                  value={service}
                  options={serviceOptions}
                  autoFocus={true}
                  label={"Service"}
                  onChange={handleServiceChange}
                  disabled={isView || isEdit}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <CustomTextFieldWithSearch
                  clearField={clearField}
                  setClearField={setClearField}
                  onChange={handleAssetNoChange}
                  onClear={handleDescClear}
                  options={assetnoOptions}
                  isMandatoryField={true}
                  label="Asset No."
                  value={assetno}
                  disabled={isView || isEdit}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <CustomTextField
                  onChange={(newvalue) => setassetdesc(newvalue)}
                  label="Asset Description"
                  value={assetdesc}
                  disabled={true}
                />
              </Grid>
            </Grid>
          </Stack>
          <Grid container mb={2} spacing={4}>
            <Grid item xs={6} md={4}>
              <CustomTextField
                onChange={(newvalue) => setTypeCode(newvalue)}
                label="Type Code"
                value={typecode}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                onChange={(newvalue) => setTypeDesc(newvalue)}
                label="Type Code Description"
                value={typedesc}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Stack direction={"row"} mb={1} justifyContent={"end"} spacing={1.5}>
            {!isView && (
              <Button
                variant="contained"
                onClick={() => {
                  toggleModal(true)();
                  setDate(currentDate);
                }}
                disabled={!assetno.label}
              >
                Add
              </Button>
            )}
          </Stack>
          <CustomAgGrid
            ref={gridApi}
            setGridApi={setGridApi}
            rows={rowData}
            columns={colDefs}
            pagination={true}
            disableFilter
          />
        </DefaultCard>
        <DefaultCard>
          <Typography variant="title2">Disposal Status</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} mt={2} md={3}>
              <CustomDatePicker
                onDateChange={handleDisposalApprovalChange}
                label="Disposal Approval Date"
                disabled={isView || !assetno.label}
                value={disposalApproval}
              />
            </Grid>

            <Grid item xs={6} mt={2} md={3}>
              <CustomDatePicker
                onDateChange={handleDisposalDateChange}
                label="Disposal Date"
                value={disposalDate}
                disabled={isView || !assetno.label}
              />
            </Grid>
            <Grid item xs={6} mt={2} md={3}>
              <CustomTextField
                onChange={handleDisposalByChange}
                label="Disposal By"
                value={disposalBy}
                disabled={isView || !assetno.label}
                error={errors.disposalBy}
                helperText={errorMessages.disposalBy}
              />
            </Grid>

            <Grid item xs={6} mt={2} md={3}>
              <CustomTextField
                onChange={handleDisposalMethodChange}
                label="Disposal Method"
                value={disposalMethod}
                disabled={isView || !assetno.label}
                error={errors.disposalMethod}
                helperText={errorMessages.disposalMethod}
              />
            </Grid>
          </Grid>
        </DefaultCard>
        <Stack direction={"row"} spacing={1.5} mt={2} justifyContent={"end"}>
          {!isView && (
            <Button
              variant="contained"
              disabled={!assetno.label}
              onClick={handleAssetStatusSave}
            >
              Save
            </Button>
          )}
          <Button variant="outlined" onClick={handleDisposalCancel}>
            Back
          </Button>
        </Stack>
        <Modal open={open}>
          <Box sx={ModalStyle}>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography variant="title2">Add an Update</Typography>
              <IconButton onClick={handleModalCancel}>
                <HighlightOffIcon />
              </IconButton>
            </Stack>
            <Stack gap={4} mt={2} direction={"row"}>
              <Box width={"50%"}>
                <CustomDatePicker
                  minimumDate={rowData[rowData.length - 1]?.date}
                  modal={open}
                  label="Date"
                  value={date}
                  maxDate={currentDate}
                  isMandatoryField={true}
                  id="date"
                  onDateChange={handleDateChange}
                  helperText={errorMessages.date}
                  error={errors.date}
                />
              </Box>
              <Box width={"50%"}>
                <CustomSelectInput
                  modal={open}
                  error={errors.equipmentCondition}
                  helperText={errorMessages.equipmentCondition}
                  disableClearable={true}
                  label="Equipment Condition"
                  value={equipmentCondition}
                  options={statusOptions}
                  isMandatoryField={true}
                  id="euipmentCondition"
                  onChange={handleEquipmentConditionChange}
                />
              </Box>
            </Stack>
            <Stack direction={"row"} gap={1.5} mt={3} justifyContent={"end"}>
              <Button variant="contained" onClick={handleConditionSave}>
                Add
              </Button>
              <Button variant="outlined" onClick={handleModalCancel}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>
        <CustomDialog
          cancelBtn={"No"}
          open={openDialog}
          onConfirm={handleDialogConfirm}
          content={dialogContent}
          onClose={handleDialogClose}
          confirmBtn={"Yes"}
        />
        <CustomDialog
          open={openValidationDialog}
          onConfirm={handleDialogConfirm}
          content={dialogContent}
          onClose={handleDialogClose}
          confirmBtn={"Ok"}
        />
      </Box>
    </>
  );
};

export default AssetConditionForm;
